import { Service } from 'components/system';
import { A9Service } from 'components/system/angular/A9Service';
import angular from 'angular';
import { RsCustomerImageInfo } from 'common/customers/services/types/RsCustomerImageInfo';

export enum CustomerImageUploadServiceEvents {
    UPLOADED = 'image-uploaded'
}

@A9Service('customerImageUploadService')
class CustomerImageUploadService extends Service {
    constructor(private $http: angular.IHttpService) {
        super();
    }

    public uploadMainImage(customerId, file): Promise<RsCustomerImageInfo> {
        const fd = new FormData();
        fd.append('fileData', file);
        const result = this.$http({
            method: 'POST',
            url: `middle://rs/customers/${customerId}/images`,
            data: fd,
            transformRequest: angular.identity,
            headers: {
                'Content-Type': undefined
            },
            params: {
                main: true
            }
        })
            .then(response => {
                this.emit(CustomerImageUploadServiceEvents.UPLOADED, customerId);
                return response.data;
            })
            .catch(error => {
                throw new Error(error.message);
            });

        return <Promise<RsCustomerImageInfo>>result;
    }
}
